module.exports = __webpack_public_path__ + "static/media/IMG_0446_Reduced.91af3552.jpg";